import { ArrowUpRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Reveal } from '../components/Reveal';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { guides } from '../content/site';

export function Guides() {
  return (
    <>
      <section className="page-hero section-shell">
        <Breadcrumbs items={[{ label: 'Guides' }]} />
        <div className="page-hero__grid">
          <Reveal><p className="section-kicker">Project planning</p><h1>Understand the work before the proposal.</h1></Reveal>
          <Reveal delay={0.08}><p className="page-hero__lede">Useful questions and practical explanations for masonry, concrete, retaining walls, and drainage.</p></Reveal>
        </div>
      </section>
      <section className="guide-index section-pad section-shell">
        {guides.map((guide, index) => (
          <Reveal as="article" key={guide.slug} delay={index * 0.07} variant="media">
            <ResponsiveImage src={guide.image} alt={guide.imageAlt} width="1000" height="680" loading={index ? 'lazy' : 'eager'} />
            <div><span>{guide.readTime}</span><h2>{guide.title}</h2><p>{guide.description}</p><Link className="text-link" to={`/guides/${guide.slug}`}>Read guide <ArrowUpRight aria-hidden="true" size={17} /></Link></div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
